$(document).ready(function () {
  var stickySection = $('.section-cover');
  if (stickySection.length) {
    var stickyOffset = stickySection.offset().top;
    $(window).scroll(function () {
      var sticky = $('.section-cover'),
        scroll = $(window).scrollTop();

      if (scroll >= stickyOffset) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
    });
  }
});

let $root = $('html, body');
$('a[href^="#"]').click(function () {
  let href = $.attr(this, 'href');
  $root.animate(
    {
      scrollTop: $(href).offset().top,
    },
    500,
    function () {
      window.location.hash = href;
    }
  );
  return false;
});

$(document).ready(function () {
  $(document).on('click', '.tooltip', function () {
    setTimeout(function () {
      var price_p = $('.b_test').find('.span').text();

      $('.price_ch').text(price_p);
      $('.test_price span').css('display', 'none');
    }, 100);
  });

  $(document).on('click', '.btn-1', function () {
    var items = [
      { quantity: 1, id: 41305381601489 },
      { quantity: 1, id: 41305381175505 },
    ];

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: items,
      },
      dataType: 'json',
      success: function (data) {
        document.location.href = '/cart';
      },
    });
  });
});

$(document).ready(function () {
  $('i.upper_ap.fa.fa-angle-down').on('click', function (e) {
    e.preventDefault();
    $('ul.class_ul').slideToggle();
  });
  $('#trigger-overlay').on('click', function () {
    $('.overlay').addClass('open');
    $('button.overlay-close').addClass('show');
    $('#trigger-overlay').addClass('hide');
    $('.hide_start').removeClass('hide_start');
  });
  $('.overlay-close').on('click', function () {
    $('.hide_start').addClass('hide_start');
    $('.overlay').removeClass('open');
    $('button.overlay-close ').removeClass('show');
    $('#trigger-overlay').removeClass('hide');
  });
});
